import { render, staticRenderFns } from "./boxInTheBox.vue?vue&type=template&id=0eaa4921&scoped=true&"
import script from "./boxInTheBox.vue?vue&type=script&lang=js&"
export * from "./boxInTheBox.vue?vue&type=script&lang=js&"
import style0 from "./boxInTheBox.vue?vue&type=style&index=0&id=0eaa4921&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaa4921",
  null
  
)

export default component.exports